import { useRequestData } from 'wsm-common-data';

export function useIsMobile() {
	const { deviceType } = useRequestData();
	const isMobile = deviceType.toLowerCase() === 'mobile';

	return { isMobile };
}
